const steps = [
  { title: "Kennismaken", text: "We bespreken jullie LOB-programma en wensen." },
  { title: "Inrichten", text: "Samen richten we de leerlijn in op jullie school." },
  { title: "Starten", text: "Mentoren en leerlingen gaan aan de slag." },
  { title: "Begeleiden", text: "We ondersteunen het team tijdens het schooljaar." },
  { title: "Evalueren", text: "We kijken samen terug en stellen bij." },
];

const ImplementationSection = () => (
  <section className="py-24 lg:py-28 animate-on-scroll bg-accent/40">
    <div className="container mx-auto max-w-6xl px-4 sm:px-6">
      <div className="max-w-2xl mx-auto text-center mb-12">
        <span className="inline-block text-[11px] font-bold tracking-[0.2em] uppercase text-primary mb-4 px-3 py-1 bg-card rounded-full">
          Implementatie
        </span>
        <h2 className="text-3xl lg:text-[2.4rem] font-extrabold text-secondary leading-tight [text-wrap:balance]">
          Samen met jullie school ingericht en geïntroduceerd.
        </h2>
      </div>
      <ol className="relative grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
        <div className="hidden lg:block absolute top-5 left-[10%] right-[10%] h-0.5 bg-primary/30" />
        {steps.map((s, i) => (
          <li key={s.title} className="relative text-center">
            <div className="relative z-10 mx-auto mb-4 flex h-10 w-10 items-center justify-center rounded-full bg-primary text-sm font-extrabold text-primary-foreground shadow-medium">
              {i + 1}
            </div>
            <h3 className="font-extrabold text-secondary">{s.title}</h3>
            <p className="mt-1 text-sm text-muted-foreground">{s.text}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default ImplementationSection;
